import { Stack } from '@mui/material'
import { AnimatedLoader } from '~sharedUI'

export const LoadPageProgress = () => {
	return (
		<Stack
			sx={{ height: '100%', width: '100%' }}
			justifyContent={'center'}
			alignItems={'center'}
			alignSelf={'center'}
			spacing={2}
		>
			<AnimatedLoader />
		</Stack>
	)
}
